import {
  Action,
  domen,
  newInvocesToken,
  reloadSaveStatuses,
  saveToken,
  Trigger,
} from '../../defaults';

export const saveNewTriggers: Trigger[] = [
  {
    events: ['on-change-any-data-param'],
    targets: [saveToken],
    handlers: ['add-save-new-requests', 'save-new', 'add-invoces-pending'],
    expr: {
      type: 'func',
      value: `({hashMap}) => hashMap['${saveToken}'].data.customData.saveStatus === 'valid' 
      && !hashMap['${saveToken}'].data.customData['${reloadSaveStatuses['saved-new']}']
      && !!hashMap['${newInvocesToken}'].child.length`,
    },
  },

  {
    events: ['data-fetch-success'],
    targets: [saveToken],
    handlers: [
      'saveStatus-to-saved-new',
      'remove-save-new-request',
      'subtract-invoces-pending',
    ],
    expr: {
      type: 'func',
      value: `({sourceAction}) => sourceAction.token === 'save-new'`,
    },
  },

  {
    events: ['data-fetch-error'],
    targets: [saveToken],
    handlers: ['remove-save-new-request', 'subtract-invoces-pending', 'show-modal-error'],
    expr: {
      type: 'func',
      value: `({sourceAction}) => sourceAction.token === 'save-new'`,
    },
  },
];

export const saveNewActions: Action[] = [
  {
    kind: 'changes',
    token: 'add-save-new-requests',
    spec: {
      target: saveToken,
      changes: {
        [`data.customData.${reloadSaveStatuses['saved-new']}`]: {
          type: 'val',
          value: true,
        },
      },
    },
  },

  {
    kind: 'api',
    token: 'save-new',
    spec: {
      uri: `${domen}/v1/tck/bms/invoices/create-batch`,
      method: 'POST',
      ignoreCanceledRequest: true,
      data: {
        app: {
          type: 'func',
          value: '({config}) => config.custom.app',
        },
        token: {
          type: 'func',
          value: '({config}) => config.custom.token',
        },
        timezone: {
          type: 'func',
          value: '({config}) => config.custom.timezone',
        },
        ticket_id: {
          type: 'func',
          value: '({config}) => config.custom.ticketId',
        },
        invoices: {
          type: 'func',
          value: `({hashMap}) => {
  const newInvoces = hashMap['${newInvocesToken}'].child

  return payloadInvoices = newInvoces.map(({child}) => {
    const linkToken = child.find(({token}) => token.endsWith('_link'))?.token
    const fileToken = child.find(({token}) => token.endsWith('_file'))?.token
    const totalToken = child.find(({token}) => token.endsWith('_price')).token

    const link = hashMap[linkToken]
    const file = hashMap[fileToken]

    const data = !!link ? {url: link.data.value} : {file_id: file.data.value[0].id}

    return {
      total: hashMap[totalToken].data.value,
      ...data
    }
  })
}`,
        },
      },
    },
  },

  {
    kind: 'changes',
    token: 'saveStatus-to-saved-new',
    spec: {
      target: saveToken,
      changes: {
        'data.customData.saveStatus': {
          type: 'val',
          value: reloadSaveStatuses['saved-new'],
        },
      },
    },
  },

  {
    kind: 'changes',
    token: 'remove-save-new-request',
    spec: {
      target: saveToken,
      changes: {
        [`data.customData.${reloadSaveStatuses['saved-new']}`]: {
          type: 'val',
          value: false,
        },
      },
    },
  },
];
